import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight, Globe, Sparkles } from 'lucide-react';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Surf Packages', path: '/packages' },
  { label: 'Rooms', path: '/rooms' },
  { label: 'Activities', path: '/activities' },
  { label: 'Blog', path: '/blog' },
  { label: 'Store', path: '/store' },
];

const socialLinks = [
  { icon: Globe, label: 'Instagram', href: 'https://www.instagram.com/girls.only.hostel.tamraght?igsh=MWl5NTVyNzJ0aWwy' },
  { icon: Phone, label: 'WhatsApp', href: 'https://wa.me/212604689422' },
  { icon: Mail, label: 'Email', href: 'mailto:contact@mermaidsonlyhostel.com' },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#2B1218] text-[#FAF3E0] mt-auto border-t border-girly-pink/20 relative overflow-hidden">
      {/* Footer content */}
      <div className="pt-16 pb-8 px-6 md:px-12 lg:px-20 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* About */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <img
                  loading="lazy"
                  src="/images/mermaids/Logo2.svg"
                  alt="Mermaids Only Logo"
                  className="h-14 w-auto object-contain"
                />
                <div className="flex flex-col">
                  <span className="font-heading text-xl font-bold tracking-wider text-white">
                    MERMAIDS <span className="text-[#F14909]">ONLY</span>
                  </span>
                  <span className="font-body text-[10px] uppercase tracking-[0.2em] text-[#FFA5C1] font-bold">
                    GIRLS-ONLY SURF CAMP & HOSTEL
                  </span>
                </div>
              </div>
              <p className="font-body text-[#FAF3E0]/75 leading-relaxed max-w-md mb-6 font-light">
                Morocco's premier girls-only & women-only surf camp & hostel in Tamraght. We welcome female surfers, yogis, travelers, and ocean dreamers into a supportive ocean sisterhood by the sea.
              </p>
              <div className="flex items-center gap-2 text-[#FFA5C1]">
                <MapPin className="w-4 h-4 text-[#F14909]" />
                <span className="font-body text-sm font-medium">Tamraght, Agadir, Morocco</span>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-heading text-lg text-white mb-6 flex items-center gap-2">
                <Sparkles className="w-4 h-4 text-[#FFA5C1]" />
                Quick Links
              </h3>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="font-body text-[#FAF3E0]/75 hover:text-[#FFA5C1] transition-colors duration-300 flex items-center gap-1 group font-light"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity text-[#F14909]" />
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/contact"
                    className="font-body text-[#FAF3E0]/75 hover:text-[#FFA5C1] transition-colors duration-300 flex items-center gap-1 group font-light"
                  >
                    Contact
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity text-[#F14909]" />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div>
              <h3 className="font-heading text-lg text-white mb-6 flex items-center gap-2">
                <Sparkles className="w-4 h-4 text-[#FFA5C1]" />
                Connect With Us
              </h3>
              <ul className="space-y-3">
                {socialLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-body text-[#FAF3E0]/75 hover:text-[#FFA5C1] transition-colors duration-300 flex items-center gap-3 group font-light"
                    >
                      <link.icon className="w-5 h-5 text-[#F14909] group-hover:scale-110 transition-transform" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Divider + Copyright */}
          <div className="border-t border-[#FAF3E0]/15 pt-8 mt-12">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4 text-sm font-body text-[#FAF3E0]/70">
                <Link to="/terms" className="hover:text-[#FFA5C1] transition-colors">Terms & Conditions</Link>
                <span className="text-[#FAF3E0]/40">|</span>
                <Link to="/faq" className="hover:text-[#FFA5C1] transition-colors">FAQs</Link>
              </div>
              <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
                <p className="font-body text-sm text-[#FAF3E0]/70 text-center md:text-right">
                  © {new Date().getFullYear()} Mermaids Only Hostel. All rights reserved.
                </p>
                <p className="font-body text-sm text-[#FFA5C1] hidden md:block">
                  Made with 🏄‍♀️ 🌸 🌊 in Tamraght, Morocco
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
